import styled from 'styled-components';

export const Tabs = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
`;

export const Tab = styled.p`
  cursor: pointer;
  margin-right: 40px;
  padding-bottom: 6px;
  font-size: 16px;
  color: #3ea5ff;
`;

export const DataTab = styled(Tab)`
  border-bottom: ${(props) => {
    if (props.active === 'data') return 'solid 4px #3ea5ff';
  }};
  font-weight: ${(props) => {
    if (props.active === 'data') return 'bold';
  }};
`;
export const RfidTab = styled(Tab)`
  border-bottom: ${(props) => {
    if (props.active === 'rfid') return 'solid 4px #3ea5ff';
  }};
  font-weight: ${(props) => {
    if (props.active === 'rfid') return 'bold';
  }};
`;
export const EpmTab = styled(Tab)`
  border-bottom: ${(props) => {
    if (props.active === 'epm') return 'solid 4px #3ea5ff';
  }};
  font-weight: ${(props) => {
    if (props.active === 'epm') return 'bold';
  }};
`;

export const PlatesTab = styled(Tab)`
  border-bottom: ${(props) => {
    if (props.active === 'plates') return 'solid 4px #3ea5ff';
  }};
  font-weight: ${(props) => {
    if (props.active === 'plates') return 'bold';
  }};
`;

export const SubscriptionTab = styled(Tab)`
  border-bottom: ${(props) => {
    if (props.active === 'subscription') return 'solid 4px #3ea5ff';
  }};
  font-weight: ${(props) => {
    if (props.active === 'subscription') return 'bold';
  }};
`;

export const ZonesTab = styled(Tab)`
  border-bottom: ${(props) => {
    if (props.active === 'zoneslimit') return 'solid 4px #3ea5ff';
  }};
  font-weight: ${(props) => {
    if (props.active === 'zoneslimit') return 'bold';
  }};
`;

export const LKTab = styled(Tab)`
  border-bottom: ${(props) => {
    if (props.active === 'lk') return 'solid 4px #3ea5ff';
  }};
  font-weight: ${(props) => {
    if (props.active === 'lk') return 'bold';
  }};
`;

export const CountersTab = styled(Tab)`
  border-bottom: ${(props) => {
    if (props.active === 'counters') return 'solid 4px #3ea5ff';
  }};
  font-weight: ${(props) => {
    if (props.active === 'counters') return 'bold';
  }};
`;
